import React, { useMemo } from 'react'
import GenericDetails from '../GenericDetails'

const ContractorBusinessPanel = (props) => {
  const { config = {}, record = {} } = props
  
  const alteredConfig = useMemo(() => {
    if (!config.FieldSettings) return config
    return {
      ...config,
      FieldSettings: {
        ...config.FieldSettings['Business'].Fields,
      },
    }
  }, [config])

  const businessTabNumber = useMemo(() => {
    return config.Tabs.find((t) => t.Title === 'Business').Order || 3
  }, [config])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <GenericDetails activeTabId={businessTabNumber} record={record.Business} config={alteredConfig} />
    </div>
  )
}

export default ContractorBusinessPanel
